// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-info-container-header {
   display: flex;
   flex-direction: row-reverse;
   align-items: center;
}

.user-profile-trigger{
   background-color:  unset;
}

.user-profile-trigger:hover{
   /* There is an overriding specificity in GSS for button:hover:not(:disabled)
   that this gets around */
   background-color: unset !important;
}

.user-profile-trigger label{
   cursor: pointer;
}

.user-info-container-header img {
   width: 35px;
   height: 35px;
}

/* may be necessary, not sure yet */
.user-info-container-header[data-hide-name="true"] {
   flex-direction: row;
}

.user-info-container {
   display: flex;
   flex-direction: row-reverse;
   align-items: center;
   justify-content: flex-end;
   /* background-color: inherit !important; */
}

.user-info-container label {
    font-weight: normal;
}


.user-info-container-rich-text {
   display: flex;
   flex-direction: row-reverse;
   align-items: center;
   justify-content: flex-end;
   cursor: pointer;
}

.user-info-container-rich-text img {
   width: 30px;
   height: 30px;
}

/* may be necessary, not sure yet */
.user-info-container[data-hide-name="true"] {
   flex-direction: row;
}

.user-info-container img {
   width: 30px;
   height: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLUserInfo/ECLUserInfo.css"],"names":[],"mappings":"AAAA;GACG,aAAa;GACb,2BAA2B;GAC3B,mBAAmB;AACtB;;AAEA;GACG,wBAAwB;AAC3B;;AAEA;GACG;0BACuB;GACvB,kCAAkC;AACrC;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,YAAY;AACf;;AAEA,mCAAmC;AACnC;GACG,mBAAmB;AACtB;;AAEA;GACG,aAAa;GACb,2BAA2B;GAC3B,mBAAmB;GACnB,yBAAyB;GACzB,0CAA0C;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;GACG,aAAa;GACb,2BAA2B;GAC3B,mBAAmB;GACnB,yBAAyB;GACzB,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,YAAY;AACf;;AAEA,mCAAmC;AACnC;GACG,mBAAmB;AACtB;;AAEA;GACG,WAAW;GACX,YAAY;AACf","sourcesContent":[".user-info-container-header {\r\n   display: flex;\r\n   flex-direction: row-reverse;\r\n   align-items: center;\r\n}\r\n\r\n.user-profile-trigger{\r\n   background-color:  unset;\r\n}\r\n\r\n.user-profile-trigger:hover{\r\n   /* There is an overriding specificity in GSS for button:hover:not(:disabled)\r\n   that this gets around */\r\n   background-color: unset !important;\r\n}\r\n\r\n.user-profile-trigger label{\r\n   cursor: pointer;\r\n}\r\n\r\n.user-info-container-header img {\r\n   width: 35px;\r\n   height: 35px;\r\n}\r\n\r\n/* may be necessary, not sure yet */\r\n.user-info-container-header[data-hide-name=\"true\"] {\r\n   flex-direction: row;\r\n}\r\n\r\n.user-info-container {\r\n   display: flex;\r\n   flex-direction: row-reverse;\r\n   align-items: center;\r\n   justify-content: flex-end;\r\n   /* background-color: inherit !important; */\r\n}\r\n\r\n.user-info-container label {\r\n    font-weight: normal;\r\n}\r\n\r\n\r\n.user-info-container-rich-text {\r\n   display: flex;\r\n   flex-direction: row-reverse;\r\n   align-items: center;\r\n   justify-content: flex-end;\r\n   cursor: pointer;\r\n}\r\n\r\n.user-info-container-rich-text img {\r\n   width: 30px;\r\n   height: 30px;\r\n}\r\n\r\n/* may be necessary, not sure yet */\r\n.user-info-container[data-hide-name=\"true\"] {\r\n   flex-direction: row;\r\n}\r\n\r\n.user-info-container img {\r\n   width: 30px;\r\n   height: 30px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
